<template>
  <div>
    <ParentBar />
    <PermissionValidation :marketId="marketId" rule="enableViewAreas">
      <layout :isSuccess="isSuccess">
        <template v-slot:headZone>
          <headline :content="getMarketName" :badge-content="getMarketCount + ' ' + $t('area.space')">
            <div class="text-right d-block">
              <v-btn color="primary" class="me-2" @click="isSearchAvailableArea = true">
                <v-icon left>mdi-calendar-plus-outline</v-icon>{{ $t('area.book_empty_stall') }}
              </v-btn>
             <div class="group-menu-con">
                <div class="group-menu">
                  <button class="group-menu__btn"
                    :class="{active: viewType == 'table'}" 
                    @click="viewType = 'table'"  
                    value="table"
                  >
                    {{ $t('table') }}
                  </button>
                  <button class="group-menu__btn" 
                    :class="{active: viewType == 'plan'}"  
                    @click="viewType = 'plan'"
                    value="plan"
                  >
                    {{ $t('area.market_plan') }}
                  </button>
                  <button class="group-menu__btn" 
                    :class="{active: viewType == 'calendar'}"  
                    @click="viewType = 'calendar'"
                    value="calendar"
                  >
                    {{ $t('calendar') }}
                  </button>
                </div>
             </div>
            </div>
          </headline>
        </template>
        <template v-slot:containerZone>
          <areas
            v-if="viewType == 'table'"
            :areas="getAreas"
            @reloadContract="getMarket"
            :search="search"
            :projectId="projectId"
            :marketId="marketId"
            :summaryData="{
              booking: getAreaBookingSummaryByMarket,
              invoice: getInvoiceDueDateSummary,
              meter: hashMeterData
            }"
            :meterNotification="meterNotification"
            :isLoadingSummary="isLoadingSummary"
          />
          <div v-if="!isLoading && viewType == 'plan'">
            <ExplanationStatus :viewType="'plan'" class="btn-explain-plan"/>
            <MarketPlan  :isEdit="false" :height="height" 
              :tooltipStallId="'tooltipStallId1'" 
              :summaryData="{booking : getAreaBookingSummaryByMarket,invoice : getInvoiceDueDateSummary,meter: hashMeterData}"
              :isLoadingSummary="isLoadingSummary"
              />
          </div>
          <MarketCalendar v-if="viewType == 'calendar' && marketId" :areas="getAreas"  @reloadContract="getMarket"/>
        </template>
      </layout>
      <SearchAvailableAreaDialog
        v-model="isSearchAvailableArea"
        :marketId="marketId"
        :projectId="projectId"
        :summaryData="{booking : getAreaBookingSummaryByMarket}"
        @onSuccess="getMarket()"
      />
    </PermissionValidation>
  </div>
</template>

<script>
import Headline from "../../components/Headline.vue";
import ParentBar from "../../components/ParentBar";
import AddArea from "../../components/AddArea";
import Areas from "../../components/Areas.vue";
import { mapGetters, mapState } from "vuex";
import Layout from "../../components/Layout.vue";
import PermissionValidation from "../../components/PermissionValidation.component.vue";
import MarketPlan from "../../components/MarketPlan.vue";
import MarketCalendar from "../../components/MarketCalendar.vue";
import SearchAvailableAreaDialog from "../../components/SearchAvailableAreaDialog.component.vue";
import ExplanationStatus from "../../components/ExplanationStatus.vue";
import { DigitalMeter } from "../../classes";
export default {
  components: {
    Headline,
    ParentBar,
    AddArea,
    Areas,
    Layout,
    PermissionValidation,
    MarketPlan,
    MarketCalendar,
    SearchAvailableAreaDialog,
    ExplanationStatus
  },
  name: "MarketId",
  created() {},
  computed: {
    ...mapGetters({
      getMarketCount: "markets/getMarketCount",
      getAreas: "markets/getAreas",
      market: "markets/getMarket",
      getMarketName: "markets/getMarketName",
      getAreaBookingSummaryByMarket: "area/getAreaBookingSummaryByMarket",
      getInvoiceDueDateSummary: "area/getInvoiceDueDateSummary"
    }),
  },
  data() {
    return {
      marketId: this.$route.params.marketId,
      projectId: this.$route.params.projectId,
      isSuccess: false,
      addMarketDialog: false,
      form: {
        name: "",
        size: ""
      },
      search: "",
      viewType: "table",
      isLoading: false,
      isLoadingSummary : false,
      isSearchAvailableArea: false,
      meterNotification : {
        isMeterOffline: false,
        count : 0,
        listMeterOffline: [],
      },
      hashMeterData: {},
      meters : null,
      height: 0,
    };
  },
  created() {
    this.height = document.documentElement.clientHeight - 253;
    this.getMarket();
    if (localStorage.getItem("areaViewType"))
      this.viewType = localStorage.getItem("areaViewType");
  },
  methods: {
    async getMarket() {
      this.isLoading = true;
      try {
        await this.$store.dispatch("markets/getMarketArea", {
          id: this.marketId
        });
        this.getSummaryData();
        this.isSuccess = true;
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    async getSummaryData(){
      this.isLoadingSummary = true;
      try {
        const promise = [
          this.$store.dispatch("area/getAreaBookingSummaryByMarket", {
            marketId: this.marketId
          }),
          this.$store.dispatch("area/getInvoiceDueDateSummaryByMarket", {
            marketId: this.marketId
          }),
          this.getSummaryDigitalMeterData()
        ];
        await Promise.all(promise);
        this.isLoadingSummary = false;
      } catch (error) {
        this.isLoadingSummary = false;
        console.log(error);
      }
    },
    async getSummaryDigitalMeterData(){
      if (this.market && this.market.digitalMeterData) {
        this.meterNotification.isMeterOffline = false
        this.meterNotification.count = 0
        this.meterNotification.listMeterOffline = []
        this.hashMeterData = {}
        this.meters = await this.$store.dispatch("meter/getMeterByMarket",{
          marketId: this.marketId,
          type: "elec"
        })

        let promises = []
        for (let data of this.market.digitalMeterData) {
          promises.push(
            DigitalMeter.getLatestMeterData(
              data.partner,
              data.type,
              data.cust_id,
              null,
              new Date()
            )
          )
        }

        let results = await Promise.all(promises)
        let hashDigitalMetersUnit = {}
        for (let result of results) {
          hashDigitalMetersUnit = {
            ...hashDigitalMetersUnit,
            ...result
          }
        }

        let prepareMeterOffline = null;
        let businessName = null;
        for (const meter of this.meters) {
          if (!meter.digitalMeterData) continue;

          const meterKey = `${meter.digitalMeterData.cust_id}_${meter.digitalMeterData.meter_id}`;
          const meterData = hashDigitalMetersUnit[meterKey];
          
          if (!meterData) continue;

          const areaId = meter.area.objectId;
          if (!this.hashMeterData[areaId]) {
            this.hashMeterData[areaId] = [];
          }

          this.hashMeterData[areaId].push({...meterData, meter});

          if (meterData.isOffline && meter.digitalMeterData.partner != "xten") {
            if(meter.area.contract){
              businessName = meter.area.contract.businessName;
            }
            if(meter.area.booking){
              businessName = meter.area.booking.businessName;
            }
            prepareMeterOffline = {
              areaName: meter.area.name,
              meterName: meter.isMain ? this.$t('meter.main_meter') : this.$t('meter.sub_meter'),
              businessName: businessName,
              area : meter.area
            }
            this.meterNotification.listMeterOffline.push(prepareMeterOffline);
            this.meterNotification.isMeterOffline = true;
            this.meterNotification.count++;
          }
        }
      }
    }
  },
  watch: {
    viewType(type) {
      localStorage.setItem("areaViewType", type);
      this.$store.commit("markets/setAreaViewType", type);
    },
  }
};
</script>

<style lang="scss" scoped>
  .group-menu-con {
    display: inline-block;
    .group-menu { 
      display: flex;
      &__btn {
        width: 111px;
        height: 40px;
        font-weight: 400;
        line-height: 20px;
        text-align: center;
        border: 1px solid #777777;
        background: #F3F3F3;
        color: #777777;
        cursor:pointer;
      }
      &__btn:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        width: 98px;
      }
      &__btn:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        width: 82px;
      }
      &__btn:not(:last-child) {
        border-right: none;
      }
      
      .active {
        background: #777777;
        color: #FFFFFF;
      }
    }
  }

  .btn-explain-plan {
    position: absolute;
    right: 50px;
    bottom: 4%;
    z-index: 1;
  }
</style>
